import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=17c9bf6d&scoped=true&"
import script from "@/views/Groups/Group.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Group.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/group.scss?vue&type=style&index=0&id=17c9bf6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9bf6d",
  null
  
)

export default component.exports